// src/pages/NotFound.js
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { localePath } from "../utils/content";
import Seo from "../components/Seo";

export default function NotFound() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <>
      <Seo path={null} title="404" noindex />

      <section
        style={{
          minHeight: "70vh",
          display: "grid",
          placeItems: "center",
          background: "linear-gradient(135deg, var(--ink) 0%, var(--ink-2) 100%)",
          color: "var(--ivory)",
          padding: "100px 20px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: "radial-gradient(circle at 30% 50%, rgba(201, 162, 74, 0.18), transparent 50%)",
            pointerEvents: "none",
          }}
        />
        <div className="container" style={{ position: "relative", textAlign: "center", maxWidth: 680 }}>
          <div
            style={{
              fontFamily: "var(--serif)",
              fontSize: "clamp(120px, 22vw, 220px)",
              fontWeight: 500,
              lineHeight: 1,
              color: "var(--gold)",
              letterSpacing: "-0.04em",
              opacity: 0.9,
              marginBottom: 16,
            }}
          >
            404
          </div>
          <div
            className="eyebrow"
            style={{ color: "var(--gold-soft)", justifyContent: "center", display: "inline-flex" }}
          >
            {t("brand.short")}
          </div>
          <h1 style={{ color: "var(--ivory)", fontSize: "clamp(32px, 4vw, 48px)", margin: "16px 0 18px" }}>
            {t("common.not_found_title")}
          </h1>
          <p style={{ color: "rgba(250, 246, 236, 0.75)", fontSize: 17, marginBottom: 36 }}>
            {t("common.not_found_text")}
          </p>
          <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap" }}>
            <Link
              to={localePath(lang)}
              className="btn btn-primary"
              style={{ background: "var(--gold)", color: "var(--ink)", borderColor: "var(--gold)" }}
            >
              {t("common.back_home")}
            </Link>
            <Link
              to={localePath(lang, "contact")}
              className="btn btn-ghost"
              style={{ color: "var(--ivory)", borderColor: "rgba(250,246,236,0.3)" }}
            >
              {t("menu.contact")}
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}